import React from "react"
import logo from "../../../assets/images/crm-logo.png"
import Navigation from "./Navigation"
import {useToggle} from "usehooks-ts"
import classes from "./SideBar.module.scss"

export default function SideBar() {

  const [isWide, setIsWide] = useToggle(false)

  return (
    <div className={[classes.wrap, isWide ? classes.wide : classes.narrow].join(" ")}>
      <div className={classes.logo}>
        <img src={logo} alt=""/>
      </div>
      <div className={classes.nav}>
        <Navigation isFull={isWide}/>
      </div>
      <div
        className={classes.toggle}
        onClick={setIsWide}
      ></div>
    </div>
  )
}